import React from "react";
import { Card } from "react-bootstrap";
import "./styles.scss";

const SelectOption = ({
  type,
  image,
  setStep,
  roofData,
  setRoofData,
  nextStep,
  optionType,
}) => {
  //   const { roofSteepness } = roofData;
  return (
    <>
      <Card
        onClick={() => {
          setRoofData({
            ...roofData,
            [optionType]: type,
          });
          return setStep(nextStep);
        }}
        className={`m-2 shadow-sm roof-type-card ${
          ""
          // roofSteepness === type && "selected-roof-type"
        }`}
      >
        {/* {roofSteepness === type && (
          <img className="selected-icon" src={checkMark} alt="Selected" />
        )} */}
        <div className="">
          <img src={image} className="select-option-image" alt={type} />
        </div>
        <span> {type}</span>
      </Card>
    </>
  );
};

export default SelectOption;
